import React from 'react';
import { getTreasury, getExcel, getPaymentList, getRecaudation, getDetailFine } from './services/services';
import Breadcrumb from '../../Shared/BreadCumb';
import { ArrowDownIcon, FunnelIcon, ChevronDownIcon, ChevronUpIcon, DocumentArrowDownIcon, XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import ClipLoader from "react-spinners/ClipLoader";
import ResponsiveTable from '../../Shared/ResponsiveTable';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { ToastContainer, toast } from 'react-toastify'; 
//update
export class TreasuryComponent extends React.Component {


    constructor(props){
        super(props)
        this.state = {
            total:[],
            canSee: false,
            canConsult: false,
            loading: true,

            // to search
            dateStart: this.toLocalDateTimeString(new Date()),
            dateEnd:  this.toLocalDateTimeString(new Date()),
            dateStartRecaudation: this.toLocalDateTimeString(new Date()),
            dateEndRecaudation: this.toLocalDateTimeString(new Date()),
            limit:100,
            identification:'',
            ref:'',

            //payments
            paymentList: [],

            // UI state
            isFiltersOpen: false,
            quickFilter: '', // Nuevo estado para filtro rápido
            paymentType: 0,
            
            // Modal state
            showDetailModal: false,
            fineDetail: null,
            loadingDetail: false,
        };
    }

    toLocalDateTimeString(date) {
        // 1️⃣  Obtener componentes locales
        const year   = date.getFullYear();
        const month  = String(date.getMonth() + 1).padStart(2, '0'); // Enero = 0
        const day    = String(date.getDate()).padStart(2, '0');
        const hour   = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
      
        // 2️⃣  Construir "YYYY‑MM‑DDTHH:mm"
        return `${year}-${month}-${day}T${hour}:${minute}`;
      }
      

    BreadcrumbPages = [ 
        { name: 'Administrador', href: '#', current: false },
        { name: 'Tesorería', href: '#', current: true },
    ]

    stats = [
        { name: 'Hoy', value: 0, change: 'Valor total de Multas generadas', changeType: 'positive', category: 1 },
        { name: 'Semanal', value: 0, change: 'Valor total de Multas generadas', changeType: 'positive', category: 2 },
        { name: 'Mensual', value: 0, change: 'Valor total de Multas generadas', changeType: 'positive', category: 4 },
    ]

    columns = [
        {field:'dateReg', headerName: 'Fecha'},
        {field:'paymentFromDescrip', headerName: 'Lugar del Pago'},
        {field:'amountEurLocal', headerName: 'Euro (€)'},
        {field:'amount', headerName: 'Monto Bs'},
        {field:'originalAmount', headerName: 'Monto Principal'},
        {field:'paymentTypeDescrip', headerName: 'Tipo de pago'},
        {field:'identification', headerName: 'Identificación'},
        {field:'phone', headerName: 'Teléfono'},
        {field:'reference', headerName: 'Número de referencia'},
    ]

    formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    }

    renderActions = (row) => {
        return (
            <button 
                className="rounded-full bg-indigo-950 p-1 text-white shadow-xs hover:bg-indigo-950 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-950 dark:bg-indigo-950 dark:shadow-none dark:hover:bg-indigo-950 dark:focus-visible:outline-indigo-950"
                onClick={() => this.handleClick(row)}>
                    <MagnifyingGlassIcon aria-hidden="true" className="size-5" />
            </button>
        )
    }

    async componentWillMount(){
        await getTreasury().then((result) => {
            this.setState({total:result.data.data});
        }).catch(error => toast(error));
        this.setPermissions()
    }

    formatDateTimeWithDefaults = (dateValue, isEndDate = false) => {
        if (!dateValue) return '';
        

        if (dateValue instanceof Date) {
            const year = dateValue.getFullYear();
            const month = String(dateValue.getMonth() + 1).padStart(2, '0');
            const day = String(dateValue.getDate()).padStart(2, '0');
            const hours = String(dateValue.getHours()).padStart(2, '0');
            const minutes = String(dateValue.getMinutes()).padStart(2, '0');
            const seconds = String(dateValue.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
        }
        
        const dateString = String(dateValue);
        

        if (dateString.length === 10) { // formato YYYY-MM-DD
            const [year, month, day] = dateString.split('-');
            const defaultHour = isEndDate ? 23 : 1; // 11 PM para end, 1 AM para start
            const isoString = `${year}-${month}-${day}T${String(defaultHour).padStart(2, '0')}:00:00Z`;
            console.log('Fecha con hora por defecto:', isoString);
            return isoString;
        }
        

        if (dateString.includes('T') && dateString.length >= 16) {
            const [datePart, timePart] = dateString.split('T');
            const [hours, minutes] = timePart.split(':');
            const isoString = `${datePart}T${hours}:${minutes}:00Z`;
            console.log('Fecha con hora específica:', isoString);
            return isoString;
        }
        

        const isoString = dateString.includes('Z') ? dateString : `${dateString}Z`;
        console.log('Fecha fallback:', isoString);
        return isoString;
    }

    async getData(){
        this.setState({loading: true})
        const body = {limit:parseInt(this.state.limit)};
        if(this.state.identification !== ''){
            body.identification = this.state.identification;
        }
        if(this.state.dateStart !== ''){
            body.dateStart = this.formatDateTimeWithDefaults(this.state.dateStart, false);
        }
        if(this.state.dateEnd !== ''){
            body.dateEnd = this.formatDateTimeWithDefaults(this.state.dateEnd, true);
        }
        if(this.state.ref !== ''){
            body.ref = this.state.ref;
        }
        if(this.state.paymentType !== 0){
            body.idType = parseInt(this.state.paymentType);
        }
        await getPaymentList(body)
            .then((result) => {
                if(result && result.data) {
                    this.setState({paymentList:result.data.data.data})
                }else{
                    this.setState({paymentList:[]})
                }
                this.setState({loading:false})
            }).catch((error) => {
                toast(error);
                this.setState({loading:false})
            })
    }

    async exportRecaudation() {
        if(this.state.dateEndRecaudation === '' || this.state.dateEndRecaudation === '') {
            return toast('Debe de llenar ambos campos para poder generar el reporte')
        }
        this.setState({loading: true})
        const body = {
            dateStart: this.formatDateTimeWithDefaults(this.state.dateStartRecaudation, false),
            dateEnd: this.formatDateTimeWithDefaults(this.state.dateEndRecaudation, true),
        };
        await getRecaudation(body)
            .then((result) => {
                if(result && result.data) {
                    this.setState({paymentList:[]})
                    if(result && result.data) {
                        window.open(result.data.data.url);
                        }else{
                                toast('No se encontraron resultados');
                        }
                        this.setState({loading:false});
                        }else{
                    this.setState({paymentList:[]})
                }
                this.setState({loading:false})
            }).catch((error) => {
                toast(error);
                this.setState({loading:false})
            })
    }

    async exportData(){
        this.setState({loading: true})
        const body = {limit:parseInt(this.state.limit)};
        body.isReportExcel = true;
        if(this.state.identification !== ''){
            body.identification = this.state.identification;
        }
        if(this.state.dateStart !== ''){
            body.dateStart = this.formatDateTimeWithDefaults(this.state.dateStart, false);
        }
        if(this.state.dateEnd !== ''){
            body.dateEnd = this.formatDateTimeWithDefaults(this.state.dateEnd, true);
        }
        if(this.state.ref !== ''){
            body.ref = this.state.ref;
        }
        if(this.state.paymentType !== 0){
            body.idType = parseInt(this.state.paymentType);
        }
        await getPaymentList(body)
            .then((result) => {
                if(result && result.data) {
                    this.setState({paymentList:[]})
                    if(result && result.data) {
                        window.open(result.data.data.url);
                        }else{
                                toast('No se encontraron resultados');
                        }
                        this.setState({loading:false});
                        }else{
                    this.setState({paymentList:[]})
                }
                this.setState({loading:false})
            }).catch((error) => {
                toast(error);
                this.setState({loading:false})
            })
    }

    handleClick = (param) => {
        this.setState({loadingDetail:true, showDetailModal: true});
        const body = {
            status: -1,
            limit:1,
            idHeaderFine: param.row ? param.row.idHeaderFine : param.idHeaderFine
        }
        getDetailFine(body).then((result) => {
            console.log(result);
            this.setState({
                loadingDetail:false, 
                fineDetail: result.data.data[0],
            });
        }).catch((error) => {
            this.setState({
                loadingDetail:false,
                fineDetail: null,
            });
            toast(error);
        })
    }

    closeDetailModal = () => {
        this.setState({
            showDetailModal: false,
            fineDetail: null,
            loadingDetail: false
        });
    }

    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12;
        return `${fecha.getDate()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getFullYear()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`
    } 

    renderDetailModal = () => {
        return (
            <Dialog 
                open={this.state.showDetailModal} 
                onClose={this.closeDetailModal} 
                className="relative z-50"
            >
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-4xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            {/* Header del modal */}
                            <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                                <DialogTitle className="text-lg font-semibold text-gray-900">
                                    Detalles de la infracción
                                </DialogTitle>
                                <button
                                    type="button"
                                    onClick={this.closeDetailModal}
                                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    <span className="sr-only">Cerrar</span>
                                    <XMarkIcon className="h-6 w-6" />
                                </button>
                            </div>

                            {/* Contenido del modal */}
                            <div className="mt-6">
                                {this.state.loadingDetail ? (
                                    <div className="text-center py-8">
                                        <ClipLoader
                                            color={'#1e40af'}
                                            loading={true}
                                            size={40}
                                            aria-label="Loading Spinner"
                                        />
                                        <p className="mt-2 text-sm text-gray-600">Cargando ...</p>
                                    </div>
                                ) : this.state.fineDetail ? (
                                    <div className="space-y-6">
                                        {/* Aquí puedes agregar la información que quieres mostrar */}
                                        <div className="bg-gray-50 rounded-lg p-4">
                                            <h3 className="text-base font-medium text-gray-900 mb-3">
                                                Información
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Nombre completo
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                        {this.state.fineDetail?.firstName} {this.state.fineDetail?.middleName} {this.state.fineDetail?.firstLastName}
                                                    </p>
                                                </div>
                                                {/* Aquí puedes agregar más campos según la estructura de datos */}
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Identificación
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                        {this.state.fineDetail?.identification }
                                                    </p>
                                                </div>
                                            </div>
                                            <br></br>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Sector
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                    {this.state.fineDetail?.headerFine[0].sectorDescrip }
                                                    </p>
                                                </div>
                                                {/* Aquí puedes agregar más campos según la estructura de datos */}
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Fecha
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                        {this.formatDate(this.state.fineDetail?.headerFine[0].dateReg.split('T')[0])}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Placa del Vehiculo
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                    {this.state.fineDetail?.headerFine[0].numberPlate }
                                                    </p>
                                                </div>
                                                {/* Aquí puedes agregar más campos según la estructura de datos */}
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Tipo de vehiculo
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                        {this.state.fineDetail?.headerFine[0].typeVehicleDescrip}
                                                    </p>
                                                </div>
                                            </div>
                                            <br></br>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Detalles
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                    {this.state.fineDetail?.headerFine[0].comment }
                                                    </p>
                                                </div>
                                                {/* Aquí puedes agregar más campos según la estructura de datos */}
                                                <div>
                                                    <label className="block text-sm font-medium text-black-700">
                                                        Concepto
                                                    </label>
                                                    <p className="mt-1 text-sm text-gray-900">
                                                        {this.state.fineDetail?.headerFine[0].detailFine[0].concept }
                                                    </p>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-8">
                                        <p className="text-sm text-gray-500">
                                            No se pudo cargar la información de la multa
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Footer del modal */}
                            <div className="mt-6 flex justify-end space-x-3 pt-4 border-t border-gray-200">
                                <button
                                    type="button"
                                    onClick={this.closeDetailModal}
                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        );
    }

    setPermissions = () => {
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        if(userType === 'ANALISTA') { 
            let canConsult = false;
            let canSee = false;
            permissions = JSON.parse(permissions);
            permissions[0].treasury.forEach(element => {
                if(element.name === 'see' && element.value === true){
                    canSee = true;
                }
                if(element.name === 'search' && element.value === true){
                    canConsult = true;
                }
            });
            this.setState({canConsult:canConsult, loading:false, canSee: canSee});
        }else{
            this.setState({canSee:true, canConsult:true, loading:false});
        }
    }

    dowloadItem(id){
        getExcel({
            idCategory:id
        }).then((result) => {
            if(result && result.data ) {
                window.open(result.data.data.url);
            }
        }).catch((error) =>{
            toast(error);
        })
    }

    renderValuesByType = (category, statName) => {
        const item = this.state.total.find((item) => item.idCategory === category);
        if(item) {
            return(
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">{statName}</h3>
                        <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                            item.amount > 0 ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
                        }`}>
                            {item.amount > 0 ? 'Activo' : 'Sin datos'}
                        </div>
                    </div>
                    
                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Bolívares:</span>
                            <span className="text-sm font-bold text-blue-950">Bs. {this.formatNumber(item.amount)}</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Dólares:</span>
                            <span className="text-sm font-semibold text-green-700">USD {this.formatNumber(item.amountDolarLocal)}</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Euros:</span>
                            <span className="text-sm font-semibold text-orange-600">EUR {this.formatNumber(item.amountEurLocal)}</span>
                        </div>
                    </div>
                    
                    {item.amount > 0 && (
                        <button
                            onClick={() => {this.dowloadItem(item.idCategory)}}
                            type="button"
                            className="mt-4 w-full inline-flex items-center justify-center gap-x-1.5 rounded-md bg-green-700 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
                        >
                            
                            <DocumentArrowDownIcon aria-hidden="true" className="h-4 w-4" />
                            Reporte
                        </button>
                    )}
                </div>
            )
        }else{
            return(
                <div className="bg-white rounded-lg shadow-sm ring-1 ring-gray-200 p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">{statName}</h3>
                        <div className="px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                            Sin datos
                        </div>
                    </div>
                    <p className="text-gray-500 text-center py-8">No hay información disponible</p>
                </div>
            )
        }
    }

    
    renderFilterInput = () => {
        return(
            <div>PEPE</div>
        )        
    }

    formatNumber = (number) => {
        number = parseFloat(number);
        return number.toLocaleString('es-VE');;
    }

    handleChangeDate = (e, name) => {
        const value = e.target.value;
        this.setState({ [name]: value });
        
        // Limpiar filtro rápido cuando se cambian las fechas manualmente
        if (this.state.quickFilter !== '') {
            this.setState({ quickFilter: '' });
        }
    }

    // Función para manejar filtros rápidos de tiempo
    handleQuickFilter = (e) => {
        const value = e.target.value;
        this.setState({ quickFilter: value });
        
        if (value === '') {
            // Limpiar fechas si no se selecciona filtro rápido
            this.setState({ dateStart: '', dateEnd: '' });
            return;
        }

        const now = new Date();
        let startDate, endDate;

        switch (value) {
            case 'today':
                startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 1, 0, 0);
                endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
                this.setState({dateStart:startDate, dateEnd:endDate})
                break;
            case 'week':
                // Lunes de esta semana
                const monday = new Date(now);
                monday.setDate(now.getDate() - now.getDay() + 1);
                startDate = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate(), 1, 0, 0);
                endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
                this.setState({dateStart:startDate, dateEnd:endDate})
                break;
            case 'month':
                startDate = new Date(now.getFullYear(), now.getMonth(), 1, 1, 0, 0);
                endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
                this.setState({dateStart:startDate, dateEnd:endDate})
                break;
            case 'year':
                startDate = new Date(now.getFullYear(), 0, 1, 1, 0, 0);
                endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59);
                this.setState({dateStart:startDate, dateEnd:endDate})
                break;
            default:
                return;
        }

        // Formatear fechas para datetime-local (YYYY-MM-DDTHH:MM)
        const formatDateTimeLocal = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:00`;
        };

        this.setState({
            dateStart: formatDateTimeLocal(startDate),
            dateEnd: formatDateTimeLocal(endDate)
        });
    }

    

    renderSearch = () => {
        return (
            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200">
                {/* Header del panel de filtros */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                        <FunnelIcon className="h-5 w-5 text-gray-500" />
                        <h3 className="text-lg font-semibold text-gray-900">Filtros de Búsqueda</h3>
                    </div>
                    <button
                        onClick={() => this.setState({isFiltersOpen: !this.state.isFiltersOpen})}
                        className="flex items-center text-sm text-gray-600 hover:text-gray-900"
                    >
                        {this.state.isFiltersOpen ? 'Ocultar' : 'Mostrar'} filtros
                        {this.state.isFiltersOpen ? 
                            <ChevronUpIcon className="ml-1 h-4 w-4" /> : 
                            <ChevronDownIcon className="ml-1 h-4 w-4" />
                        }
                    </button>
                </div>
                
                {/* Contenido del panel de filtros */}
                {this.state.isFiltersOpen && (
                    <div className="p-6">
                        {/* Filtro rápido de tiempo */}
                        <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                            <select
                                id="quickFilter"
                                value={this.state.quickFilter}
                                onChange={this.handleQuickFilter}
                                className="block w-full sm:w-auto rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-blue-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm bg-white"
                            >
                                <option value="">Seleccionar período...</option>
                                <option value="today">Hoy</option>
                                <option value="week">Semana</option>
                                <option value="month">Mes</option>
                                <option value="year">Año</option>
                            </select>
                            <p className="text-xs text-blue-600 mt-1">
                                Selecciona un período y las fechas se completarán automáticamente
                            </p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <div>
                                <label htmlFor="identification" className="block text-sm font-medium text-gray-700 mb-2">
                                    Identificación
                                </label>
                                <input
                                    id="identification"
                                    value={this.state.identification}
                                    onChange={(e) => {this.setState({identification:e.target.value})}}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="reference" className="block text-sm font-medium text-gray-700 mb-2">
                                    # Referencia
                                </label>
                                <input
                                    id="reference"
                                    value={this.state.ref}
                                    onChange={(e) => {this.setState({ref:e.target.value})}}
                                    type="text"
                                    placeholder=""
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>
                            
                            

                            <div>
                                <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                    Tipo de pago
                                </label>
                                <select
                                    id="paymentType"
                                    onChange={(e) => {this.setState({paymentType:e.target.value})}}
                                    value={this.state.paymentType}
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                >
                                    <option value={0}>TODOS</option>
                                    <option value={3}>PAGO MOVIL</option>
                                    <option value={2}>TRANSFERENCIA</option>
                                    <option value={1}>EFECTIVO</option>
                                </select>
                            </div>
                            
                            <div>
                                <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                    Límite de Registros
                                </label>
                                <select
                                    id="limit"
                                    onChange={(e) => {this.setState({limit:e.target.value})}}
                                    value={this.state.limit}
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                >
                                    <option value={0}>TODOS</option>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>
                                </select>
                            </div>

                            <div>
                                <label htmlFor="dateStart" className="block text-sm font-medium text-gray-700 mb-2">
                                    Fecha Desde
                                    <br />
                                    <span className="text-xs text-gray-500 ml-1">(Seleccionar fecha y hora)</span>
                                </label>
                                <input
                                    id="dateStart"
                                    value={this.state.dateStart}
                                    onChange={(e) => {this.handleChangeDate(e, 'dateStart')}}
                                    type="datetime-local"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>

                            <div>
                                <label htmlFor="dateEnd" className="block text-sm font-medium text-gray-700 mb-2">
                                    Fecha Hasta
                                    <br />
                                    <span className="text-xs text-gray-500 ml-1">(Seleccionar fecha y hora)</span>
                                </label>
                                <input
                                    id="dateEnd"
                                    value={this.state.dateEnd}
                                    onChange={(e) => {this.handleChangeDate(e, 'dateEnd')}}
                                    type="datetime-local"
                                    className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                />
                            </div>
                        </div>
                        
                        {/* Botones de acción */}
                        <div className="mt-6 flex flex-col sm:flex-row gap-3">
                            <button
                                onClick={() => this.getData()}
                                type="button"
                                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                            > 
                                Buscar Registros
                            </button>
                            <button
                                onClick={() => this.exportData()}
                                type="button"
                                className="inline-flex items-center justify-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-green-700 rounded-md shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
                            >
                                <ArrowDownIcon aria-hidden="true" className="h-4 w-4" />
                                Descargar Excel
                            </button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    renderPaymentTable(){
        return(
            <div>
                {this.renderSearch()}
            </div>
        )
    }

    renderRecaudationReport = () => {
        return (
            <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 p-6">
                <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Informe de Recaudación</h3>
                    <p className="text-sm text-gray-600">Genera reportes de recaudación por rango de fechas específico</p>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                    <div>
                        <label htmlFor="dateStartRecaudation" className="block text-sm font-medium text-gray-700 mb-2">
                            Fecha Desde
                            <span className="text-xs text-red-500 ml-1">(* La fecha y hora son obligatorias)</span>
                        </label>
                        <input
                            id="dateStartRecaudation"
                            value={this.state.dateStartRecaudation}
                            onChange={(e) => {this.setState({dateStartRecaudation:e.target.value})}}
                            type="datetime-local"
                            title="Puedes seleccionar solo la fecha, se asignará automáticamente 1:00 AM"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                        />
                    </div>

                    <div>
                        <label htmlFor="dateEndRecaudation" className="block text-sm font-medium text-gray-700 mb-2">
                            Fecha Hasta
                            <span className="text-xs text-red-500 ml-1">(* La fecha y hora son obligatorias)</span>
                        </label>
                        <input
                            id="dateEndRecaudation"
                            value={this.state.dateEndRecaudation}
                            onChange={(e) => {this.setState({dateEndRecaudation:e.target.value})}}
                            type="datetime-local"
                            title="Puedes seleccionar solo la fecha, se asignará automáticamente 11:00 PM"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                        />
                    </div>
                </div>
                
                <button
                    onClick={() => this.exportRecaudation()}
                    type="button"
                    className="inline-flex items-center justify-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-green-700 rounded-md shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
                >   
                    <ArrowDownIcon aria-hidden="true" className="h-4 w-4" />
                    Generar Reporte de Recaudación
                </button>
            </div>
        )
    }

    render(){
        return(
            <div className="max-w-7xl mx-auto px-4">
                <Breadcrumb pages={this.BreadcrumbPages}/>
                
                {this.state.canSee ? (
                    <div className="py-6">
                        <div className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Panel de Tesorería</h2>
                            <p className="text-gray-600">Gestiona los reportes y consultas de pagos del sistema</p>
                        </div>
                        
                        {/* Cards de estadísticas */}
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
                            {this.stats.map((stat) => 
                                this.renderValuesByType(stat.category, stat.name)
                            )}
                        </div>
                        
                        {/* Informe de recaudación */}
                        {this.renderRecaudationReport()}
                    </div>
                ) : (
                    <div className="py-12 text-center">
                        <p className="text-gray-500">No posees acceso a este apartado, por favor contacta con el administrador</p>
                    </div>
                )}
                
                {this.state.loading && (
                    <div className="py-12 text-center">
                        <ClipLoader
                            color={'gray'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                )}

                {this.state.canConsult && this.renderPaymentTable()}
                
                {this.state.canConsult && (
                    <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900">Resultados de Búsqueda</h3>
                            <p className="text-sm text-gray-600">
                                {this.state.paymentList.length} registro(s) encontrado(s)
                            </p>
                        </div>
                        <div>
                            {
                                this.state.loadingDetail ? (
                                    <div className="py-12 text-center">
                                        <ClipLoader
                                            color={'gray'}
                                            loading={true}
                                            size={50}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    </div>
                                ) : null
                            }
                        </div>
                        <div className="w-full">
                            <ResponsiveTable 
                                data={this.state.paymentList} 
                                columns={this.columns} 
                                onRowClick={this.handleClick}
                                renderActions={(row) => this.renderActions(row)}
                            />
                        </div>
                    </div>
                )}
                
                {/* Modal de detalles de la multa */}
                {this.renderDetailModal()}
                <ToastContainer position="top-center" hideProgressBar={true}/>
            </div>
        )
    }
}